import declare from "dojo/_base/declare";
import BooleanRen from "csi/heading/Boolean";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import ActionData from "csi/heading/ActionData";
import { ThemeStyles } from "./ThemeStyles";
import csi from "csi/main";

const ThemeColorwayActive = declare(BooleanRen, {
	/**
	 * @override
	 * Disable comments
	 */
	canComment(ctx: Context, h: Heading): boolean {
		return false;
	},

	/**
	 * @override
	 * Cover three cases where node could be a Colorway, ColorColorway or ProductSize
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: HTMLElement, actionData: ActionData): boolean {
		const themeView = ctx.view as ThemeStyles;
		const { PARAM_COLORWAY_URL, TYPE_SIZE, TYPE_STYLE } = themeView;
		const node = ctx.getNode();
		const type = node.$Type;

		switch (type) {
			case TYPE_SIZE: {
				// output "X" if Colorway is active for given size
				const style = ctx.getRowNode();
				const colorway = ctx.getParamNode(PARAM_COLORWAY_URL);
				const active = style?.Active && colorway?.Active && !style.InactiveSizes.includes(node.$URL);

				if (ctx.bExcel) {
					// in Excel we want X rather than TRUE/FALSE
					refNode.className = "headingCenter";
				}

				refNode.innerHTML = active ? "X" : csi.EMPTY_CHAR;
				return true;
			}

			case TYPE_STYLE: {
				// no inline editing
				actionData = null;
				break;
			}
		}

		return this.inherited<boolean>(arguments, [ctx, h, refNode, actionData]);
	},

	/**
	 * @override
	 * If node type is ColorColorway, then return false for value since Colorway not yet created for it
	 */
	_getValue(ctx: Context, h: Heading): boolean {
		const { TYPE_STYLE } = ctx.view as ThemeStyles;
		return ctx.getNodeType() === TYPE_STYLE ? false : this.inherited<boolean>(arguments);
	},
});

export = ThemeColorwayActive;
